import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import MonthlyRatesPage from "@/pages/MonthlyRatesPage";
import CorporateHousingPage from "@/pages/CorporateHousingPage";
import SnowbirdPage from "@/pages/SnowbirdPage";
import TravelingNursePage from "@/pages/TravelingNursePage";
import GalleryPage from "@/pages/GalleryPage";
import LocationPage from "@/pages/LocationPage";
import FAQPage from "@/pages/FAQPage";
import ContactPage from "@/pages/ContactPage";
import IndialanticBeachRentalPage from "@/pages/IndialanticBeachRentalPage";
import MelbourneBeachHouseRentalPage from "@/pages/MelbourneBeachHouseRentalPage";
import SatelliteBeachRentalPage from "@/pages/SatelliteBeachRentalPage";
import SpaceCoastMonthlyRentalPage from "@/pages/SpaceCoastMonthlyRentalPage";
import BrevardCountyFurnishedRentalPage from "@/pages/BrevardCountyFurnishedRentalPage";
import PhotoReviewPage from "@/pages/PhotoReviewPage";
import CinematicHomePage from "@/pages/CinematicHomePage";

function App() {
  return (
    <div className="App">
      <HelmetProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<CinematicHomePage />} />
          <Route path="/monthly-rates" element={<MonthlyRatesPage />} />
          <Route path="/corporate-housing" element={<CorporateHousingPage />} />
          <Route path="/snowbird-rentals" element={<SnowbirdPage />} />
          <Route path="/traveling-nurse-housing" element={<TravelingNursePage />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/location" element={<LocationPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/contact" element={<ContactPage />} />
          {/* SEO location landing pages */}
          <Route path="/indialantic-beach-rental" element={<IndialanticBeachRentalPage />} />
          <Route path="/melbourne-beach-house-rental" element={<MelbourneBeachHouseRentalPage />} />
          <Route path="/satellite-beach-rental" element={<SatelliteBeachRentalPage />} />
          <Route path="/space-coast-monthly-rental" element={<SpaceCoastMonthlyRentalPage />} />
          <Route path="/brevard-county-furnished-rental" element={<BrevardCountyFurnishedRentalPage />} />
          <Route path="/photos-review" element={<PhotoReviewPage />} />
          <Route path="/cinematic-preview" element={<CinematicHomePage />} />
        </Routes>
      </BrowserRouter>
      </HelmetProvider>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
